/**
 * Layout Constants
 * Shared constants for Header, Footer and other layout components
 */

export const HEADER_LOGO_TEXT = "Юридическая оценка рекламных рисков";

export const HEADER_NAV_LINKS = [
  { id: "home", label: "Главная", href: "/" },
  { id: "workspace", label: "Workspace", href: "/workspace" },
  { id: "analytics", label: "Аналитика", href: "/analytics" },
  { id: "marketplace", label: "Правила", href: "/marketplace" },
  { id: "info", label: "О проекте", href: "/info" },
];

export const FOOTER_COPYRIGHT = {
  year: new Date().getFullYear(),
  text: "© {year} GigaLegal / Pushi. Все права защищены.",
};
